import { render, staticRenderFns } from "./TagsPanel.vue?vue&type=template&id=3b88e90a&scoped=true"
import script from "./TagsPanel.vue?vue&type=script&lang=js"
export * from "./TagsPanel.vue?vue&type=script&lang=js"
import style0 from "./TagsPanel.vue?vue&type=style&index=0&id=3b88e90a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b88e90a",
  null
  
)

export default component.exports